// src/components/AuthProvider.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { apiMe, apiLogin, apiLogout } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading
  const [error, setError] = useState("");

  useEffect(() => {
    let on = true;
    (async () => {
      try {
        const me = await apiMe();
        if (on) setUser(me || { id: "guest" });
      } catch (e) {
        if (on) setUser({ id: "guest" });
      }
    })();
    return () => { on = false; };
  }, []);

  async function login(username, password) {
    const r = await apiLogin(username, password);
    if (r.ok) {
      const me = await apiMe();
      setUser(me || { id: "guest" });
      return { ok: true };
    } else {
      setError(r.body?.error || "Login fallito");
      return { ok: false, error: r.body?.error };
    }
  }

  async function logout() {
    await apiLogout();
    setUser({ id: "guest" });
  }

  return (
    <AuthCtx.Provider value={{ user, loading: user === null, error, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
